import { money, calcCollectionCostGen } from './common.js';
const selfCollectionCosts = {
    tiers: [
        {
            from: 0,
            to: 1000,
            value: () => money(350),
        },
        {
            from: 1001,
            to: 2500,
            value: () => money(600),
        },
        {
            from: 2501,
            to: 5000,
            value: () => money(800),
        },
        {
            from: 5001,
            to: 10000,
            value: () => money(1000),
        },
        {
            from: 10001,
            to: 25000,
            value: () => money(1400),
        },
        {
            from: 25001,
            to: 50000,
            value: () => money(1700),
        },
        {
            from: 50001,
            to: 100000,
            value: () => money(2250),
        },
        {
            from: 100001,
            to: 250000,
            value: () => money(3050),
        },
        {
            from: 250001,
            to: 500000,
            value: () => money(5100),
        },
        {
            from: 500001,
            value: (n) => Math.round(money(5100) + Math.max(0, n - money(500000)) * 0.0067),
        },
    ],
};
export const foreignCollectionCosts = {
    tiers: [
        {
            from: 0,
            to: 1000,
            value: () => money(500),
        },
        {
            from: 1001,
            to: 2500,
            value: () => money(850),
        },
        {
            from: 2501,
            to: 5000,
            value: () => money(1200),
        },
        {
            from: 5001,
            to: 10000,
            value: () => money(1550),
        },
        {
            from: 10001,
            to: 25000,
            value: () => money(2050),
        },
        {
            from: 25001,
            to: 50000,
            value: () => money(2700),
        },
        {
            from: 50001,
            to: 100000,
            value: () => money(3450),
        },
        {
            from: 100001,
            to: 250000,
            value: () => money(4650),
        },
        {
            from: 250001,
            to: 500000,
            value: () => money(7700),
        },
        {
            from: 500001,
            value: (n) => Math.round(money(7700) + Math.max(0, n - money(500000)) * 0.01),
        },
    ],
};
export const foreignCollectionCostsOld = {
    tiers: [
        {
            from: 0,
            to: 1000,
            value: () => money(400),
        },
        {
            from: 1001,
            to: 2500,
            value: () => money(700),
        },
        {
            from: 2501,
            to: 5000,
            value: () => money(1000),
        },
        {
            from: 5001,
            to: 10000,
            value: () => money(1300),
        },
        {
            from: 10001,
            to: 25000,
            value: () => money(1700),
        },
        {
            from: 25001,
            to: 50000,
            value: () => money(2250),
        },
        {
            from: 50001,
            to: 100000,
            value: () => money(2850),
        },
        {
            from: 100001,
            to: 250000,
            value: () => money(3850),
        },
        {
            from: 250001,
            to: 500000,
            value: () => money(6400),
        },
        {
            from: 500001,
            value: (n) => Math.round(money(6400) + Math.max(0, n - money(500000)) * 0.01),
        },
    ],
};
export const calcCollectionCosts = calcCollectionCostGen(selfCollectionCosts, foreignCollectionCosts);
//# sourceMappingURL=denmark.js.map